import { Particle } from "../Particle";
import { MovesDown } from "../behaviors/MovesDown";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { PhaseChange } from "../behaviors/PhaseChange";
import { adjustColor } from "../../utils/color";
import { Fire } from "./Fire";
import { Gunpowder } from "./Gunpowder";
import { ChemicalReaction } from "../behaviors/ChemicalReaction";

export class Saltpeter extends Particle {
    static baseColor = 0xF0F0E0; // Off-white / Beige

    constructor() {
        super({
            name: "Saltpeter",
            color: adjustColor(Saltpeter.baseColor, 10),
            behaviors: [
                new MovesDown(),
                new ChemicalReaction(['Sulfur', 'Charcoal'], () => new Gunpowder(), 0.05),
                new TemperatureNormalization(20, 0.1),
                // 硝石受热易燃
                new PhaseChange([
                    {
                        temp: 300,
                        type: 'above',
                        factory: () => new Fire()
                    }
                ])
            ],
            temperature: 20,
            minTemp: -273,
            maxTemp: 1000,
            props: {
                isPowder: true,
                isFlammable: true
            }
        });
    }
}
